import React, {useState, useEffect } from "react"
import { Col, Container, Row, Button } from "react-bootstrap"
import { FaHistory, FaPlus, FaPencilAlt } from 'react-icons/fa'
import "datatables.net-dt/js/dataTables.dataTables"
import "datatables.net-dt/css/jquery.dataTables.min.css"
import $ from 'jquery'; 
import Loader from "./Loader";

import AddTenantUser from './AddTenantUser'
import EditTenantUser from './EditTenantUser'
import ManageTenantUserAudit from './Manage_Tenant_User_Audit'
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import N from '../lib/Network'
import S from '../lib/Security'
var CryptoJS = require("crypto-js");
const ManageTenantUser = () => {
    const [showUserPopup, setShowUserPopup] = useState(false);
    const [showUserPopupAudit, setshowUserPopupAudit] = useState(false);
    const [showLoader, setShowLoader] = useState(false);
    const [showUserPopupEdit, setShowUserPopupEdit] = useState(false);
    const [data, setData] = useState([]);
    const [oldRecord,setOldRecord] = useState([]);
    useEffect(() => {
        showLoaderPopup();
        getKeys();
        fetchdatatableData();
        //initialize datatable
        setTimeout(function () {
            $('#viewTenantUser').DataTable({
                pagingType: 'full_numbers',
                pageLength: 7,
                processing: true,
                dom: 'Bfrtip',
                "columns":[  
                    { 'searchable': true },  
                    { 'searchable': true },  
                    { 'searchable': true },  
                    { 'searchable': true },   
                    {},
                ],
                language: { search: "", searchPlaceholder: "Search By ......"},
                buttons: [
                    {
                        text: '<i class="fa fa-print" />',
                        className: 'custom-btn',
                        extend: 'print'
                    },
                    {
                        text: '<i class="fa fa-file-excel-o" />',
                        className: 'custom-btn',
                        extend: 'csv'
                    }
                ],
                bDestroy: true,
                "initComplete": function() {
                    $(this).show();
                }
            });
            closeLoader();
        }, 1400 ); 
    }, []);
    var tenant = {};
    const fetchdatatableData = () => {
        tenant = {tenantId:localStorage.getItem("tenantId")};
           N.postApi('getTenantUserList',tenant)
          .then(res => {
            var response = S.getDecryptedJSON(res);
            console.log("response.responseJson:"+JSON.stringify(response.responseJson))
            setData(JSON.parse(response.responseJson))
          })
    }
    function getKeys(){
        if(S.getPrivateKey() == '' && S.getPublicKey() == ''){
          N.getRSAApi('/getRsaKeys')
          .then(res => {
              let resObj = JSON.parse(res.data);
              let resJson = JSON.parse(resObj.responseJson);
              if(resJson.privateKey && resJson.publicKey){
                  let newKey = CryptoJS.enc.Utf8.parse('NexStepPrivacy@#');
                  // Decrypt
                  var privateKeyBytes = CryptoJS.AES.decrypt(resJson.privateKey, newKey, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7});
                  S.privateKey = privateKeyBytes.toString(CryptoJS.enc.Utf8);
      
                  var publicKeyBytes = CryptoJS.AES.decrypt(resJson.publicKey, newKey, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7});
                  S.publicKey = publicKeyBytes.toString(CryptoJS.enc.Utf8);
                  fetchdatatableData();
              }
          })
          .catch(err => {
              console.log("Error : "+err);
          });
        }
    }
    const showLoaderPopup = () => { setShowLoader(true) }
    const closeLoader = () => { setShowLoader(false) }
    const openAuditModalHandler = () => { setshowUserPopupAudit(true) }
    const closeAuditPopup = () => { setshowUserPopupAudit(false) }
    const openPreviewModalHandler = () => {  setShowUserPopup(true); }
    const closePopup = () => { setShowUserPopup(false); }
    const closeEditPopup = () => { setShowUserPopupEdit(false) }
    const handleEdit =(oldData)=>{console.log("oldRecord:"+JSON.stringify(oldData)); setOldRecord({oldData});setShowUserPopupEdit(true); }
    return (
        <div id="content-wrapper" className="d-flex flex-column">
            <div id="wrapper">
                {<Sidebar />}
                {<Topbar />}
                {/* <!-- End of Topbar --> */}
                {/* <!-- Main Content --> */}
                <div id="content">
                    {/* <!-- Begin Page Content --> */}
                    <Container fluid>
                        <Row>
                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-12 mb-2 mt-2">
                                <div className="card dash-data-card">
                                    <div className="card-header pl-4 pr-4">
                                        <h5 className="headerTitle float-left mt-1">Manage Tenant Users</h5>
                                        <Button variant='light' type="button" className="btn btn-sm shadow-sm float-right ml-2" title="Audit Log" onClick={()=>{openAuditModalHandler();}}>
                                            <FaHistory className="fas fa-plus" /><b style={{verticalAlign: 'middle'}}>Audit Log</b>
                                        </Button>
                                        {(localStorage.getItem("isCreateTenantUserRole")) ?
                                            <Button type="button" className="btn btn-sm btn-primary shadow-sm float-right" onClick={() => openPreviewModalHandler()}>
                                                <FaPlus className="fas fa-plus pr-1" /><b style={{verticalAlign: 'middle'}}>Create Tenant User</b>
                                            </Button>
                                        : null }
                                    </div>
                                </div>
                            </div>
                        </Row>
                        <Row className="mb-3">
                            <Col lg='12'>
                                <div className="card dash-data-card">
                                    <div className="card-body pl-4 pr-4">
                                    {(localStorage.getItem("isModifyTenantUserRole")) ?
                                        <table id="viewTenantUser" className="display">
                                            <thead>
                                                <tr>
                                                    <th>Email Id</th>
                                                    <th>First Name</th>
                                                    <th>Last Name</th>
                                                    <th>Tenant User Code</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                            {data?.Payload?.tenantUserList?.map((result) => {
                                                return (
                                                    <tr>
                                                        <td>{result.Email_Id}</td>
                                                        <td>{result.First_Name}</td>
                                                        <td>{result.Last_Name}</td>
                                                        <td>{result.Tenant_User_Code}</td>
                                                        <td>
                                                            <Button variant='light' className='btn-sm' onClick={()=>handleEdit(result)}><FaPencilAlt /></Button>
                                                        </td>
                                                    </tr>
                                                    )
                                                })}
                                            </tbody>
                                        </table> :
                                        <table id="viewTenantUser" className="display">
                                        <thead>
                                            <tr>
                                                <th>Email Id</th>
                                                <th>First Name</th>
                                                <th>Tenant User Code</th>
                                                <th>Employee Id</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                        {data?.Payload?.tenantUserList?.map((result) => {
                                            return (
                                                <tr>
                                                    <td>{result.Email_Id}</td>
                                                    <td>{result.First_Name}</td>
                                                    <td>{result.Tenant_User_Code}</td>
                                                    <td>{result.employeeId}</td>
                                                    <td></td>
                                                </tr>
                                                )
                                            })}
                                        </tbody>
                                    </table>
                                    }
                                        </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                    <Loader showLoader={showLoader} />
                    <AddTenantUser showUserPopup={showUserPopup} closeModal={() => closePopup()}/>
                    {showUserPopupAudit ? <>
                       <ManageTenantUserAudit showUserPopupAudit={showUserPopupAudit} closeModal={closeAuditPopup} />
                    </> : null 
                    }
                    {showUserPopupEdit ? <>
                    <EditTenantUser oldRecord={oldRecord} showUserPopupEdit={showUserPopupEdit} closeEditModal={closeEditPopup}/>
                    </>:null
                    }
                    {/* <!-- /.container-fluid --> */}
                </div>
                {/* <!-- End of Main Content --> */}
            </div>
            {/* <!-- End of Content Wrapper --> */}
        </div>
        /* <!-- End of Page Wrapper --> */   
    )
}
export default ManageTenantUser;